import { acceptHMRUpdate, defineStore } from "pinia";
import { computed, ref } from "vue";

import type { IOperatorSettings } from "@/data/model/User";
import { useArticleAttributesStore } from "@/data/stores/articleAttribute";

import { logError } from "@/shared/logging/errors";
import { clientLanguage } from "@/shared/localization/language";

export const useOperatorSettingsStore = defineStore("operatorSettings", () => {
    const operatorSettings = ref<IOperatorSettings | null>();
    const iconAttributes = useArticleAttributesStore();

    const locationLanguage = computed(() => operatorSettings.value?.location?.language);
    const productionTileViewMode = computed(() => operatorSettings.value?.productionTileViewMode);
    function setOperatorSettings(settings: IOperatorSettings | null) {
        operatorSettings.value = settings;

        const locationId = settings?.location?.id;
        if (locationId != null) {
            iconAttributes.load(locationId, clientLanguage()).catch(logError);
        }
    }

    return {
        setOperatorSettings,
        locationLanguage,
        productionTileViewMode,

        operatorSettings
    };
});

export type OperatorSettingsStore = ReturnType<typeof useOperatorSettingsStore>;

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useOperatorSettingsStore, import.meta.hot));
}
